

















import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import { TextStyle, Alignments } from "../../../domain/drawing";
import { RectangleAreaDrawableMixin } from "./mixins";

@Component({
})
export default class TextAreaEditor extends Mixins(ModelEditableMixin, RectangleAreaDrawableMixin) {
  @Prop({ default: false })
  readonly: boolean;

  @Prop()
  textStyle: TextStyle;

  $refs!: {
    measure: HTMLTextAreaElement,
  };

  model: string = "";
  private textareaHeight: number = 0;

  get widthStyle() {
    return { width: this.rectangle.width + "px" };
  }

  get heightStyle() {
    return { height: this.textareaHeight + "px" };
  }

  get textStyles() {
    return {
      color: this.textStyle.color.value,
      fontFamily: this.textStyle.fontFamily,
      fontSize: this.textStyle.baseFontSize + "px",
      textAlign: this.textAlign(),
      alignSelf: this.alignSelf()
    };
  }

  mounted() {
    this.model = this.editingSource;
    this.updateTextareaHeight();
  }

  onChange() {
    this.editingSource = this.model;
  }

  @Watch("model")
  onModelUpdated(newValue: string, oldValue: string): void {
    this.updateTextareaHeight();
  }

  @Watch("editingSource")
  onEditingSourceUpdated(newValue: string, oldValue: string): void {
    this.model = this.editingSource;
    this.updateTextareaHeight();
  }

  @Watch("textStyles")
  onTextStylesUpdated(newValue: any, oldValue: any): void {
    this.updateTextareaHeight();
  }

  @Watch("rectangle")
  onRectangleUpdated(newValue: any, oldValue: any): void {
    this.updateTextareaHeight();
  }

  private async updateTextareaHeight() {
    await this.$nextTick();
    const lineHeight = this.textStyle.lineHeight * this.textStyle.displayFontSize;
    this.textareaHeight = Math.min(Math.max(lineHeight, this.$refs.measure.scrollHeight), this.rectangle.height);
  }

  private textAlign(): string {
    return (this.textStyle.textAlign & Alignments.Left) === Alignments.Left
      ? "left"
      : (this.textStyle.textAlign & Alignments.Center) === Alignments.Center
        ? "center"
        : (this.textStyle.textAlign & Alignments.Right) === Alignments.Right
          ? "right"
          : "";
  }

  private alignSelf(): string {
    return (this.textStyle.textAlign & Alignments.Top) === Alignments.Top
      ? "flex-start"
      : (this.textStyle.textAlign & Alignments.Middle) === Alignments.Middle
        ? "center"
        : (this.textStyle.textAlign & Alignments.Bottom) === Alignments.Bottom
          ? "flex-end"
          : "";
  }
}
